module.exports = __webpack_public_path__ + "static/media/29BDOS2.4b489448.jpg";